<template>
  <div>
    <base-select
      :title="title"
      :placeholder="placeholder"
      :search_able="true"
      :search_in_front="false"
      :float-title="true"
      :loading="loadingGetUsers"
      v-model="user_id"
      :options="options"
      :reduce="(x) => x.user_id"
      :errorMessage="errorMessage"
      :disabled-options="disabledOptions"
      :can-load-more="hasNextPageUsers"
      @loadMore="loadMoreUsers"
      :icon="icon"
    />
  </div>
</template>

<script setup>
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import { watch, onMounted, ref, defineProps, defineEmits, computed } from 'vue'
import { apiGetSiteUsers } from '@/services/users/Users'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  errorMessage: {
    type: String,
    default: null,
  },
  additionalOptions: {
    type: Array,
    default: () => [],
  },
  disabledOptions: {
    type: Array,
    default: [],
  },
})

const user_id = ref(props.modelValue)
const uuid = Math.random().toString(36).slice(2)
const loadingGetUsers = ref(false)
const users = ref([])
const hasNextPageUsers = ref(false)
const pageUsers = ref(1)

onMounted(() => {
  getUsers()

  if (props.modelValue) user_id.value = props.modelValue
})

const options = computed(() => {
  return [...props.additionalOptions, ...users.value]
})

async function getUsers(search = '') {
  loadingGetUsers.value = true
  try {
    const response = await apiGetSiteUsers(uuid, {
      search: search,
      type: 1,
      paginate: 10,
      page: pageUsers.value,
    })

    if (!response) return
    if (pageUsers.value === 1) {
      users.value = response?.data?.users?.data
    } else {
      users.value = [...users.value, ...response?.data?.users?.data]
    }
    hasNextPageUsers.value = pageUsers.value < response?.data?.users?.last_page
  } catch (error) {
    console.log(error)
  } finally {
    loadingGetUsers.value = false
  }
}

function loadMoreUsers(arg) {
  if (arg?.page) {
    pageUsers.value = arg.page
  } else {
    pageUsers.value++
  }

  if (pageUsers.value === 1) {
    users.value = []
  }
  getUsers(arg?.search || '')
}

watch(
  () => user_id.value,
  (newValue) => {
    emit('update:modelValue', newValue)
  },
)
</script>

<style scoped></style>
